module.exports = __webpack_public_path__ + "static/media/img_offer_alarms@3x.ecdb7002.png";